var $ = require('@alife/alpha-jquery/jquery');
var expressionParser = require('@alife/alpha-expression-parser/expression-parser');
var fieldUtil = require('./field');

/**
 *  不支持叶子节点为数组的情况，譬如checkbox
 * @param nameRef
 * @param jsonPath
 * @returns {*}
 */
function getValueFromDomByJsonPath(nameRef, jsonPath) {
    // 去除jsonPath中的前缀$.
    var name = jsonPath.replace('$.', '');
    // 如果存在`[`说明nameRef是对象数组，需要将jsonPath转化为同级的下标
    // 示例:
    // nameRef: products[2].packages[0].packageType
    // jsonPath: $.products[*].packages[*].packageQuantity
    if (~nameRef.indexOf('[')) {
        var array = nameRef.match(/\[\d+\]/g);
        var number = 0;
        name = name.replace(/\[\*\]/g, function () {
            return array[number++];
        });
        if (number !== array.length) {
            console.error('对应下标转换失败：下标没有严格匹配!');
        }
    }
    // 获取对应的dom
    var element = $('[name="' + name + '"]');
    // 获得其value值
    // TODO element不存在
    return fieldUtil.val(element);
}

module.exports = {
    /**
     * @param nameMap
     * {
		 *      "name1": "value1",
		 *      "multiText[3]": "value2"
		 *  }
     * @return
     * [
     *      {
		 *          "key": "name1",
		 *          "value": "value1",
		 *          "element": $element
		 *      },
     *      {
		 *          "key": "multiText[3]",
		 *          "value": "value2",
		 *          "element": $element
		 *       }
     *  ]
     */
    name2element: function (nameMap) {
        var elements = [];
        $.each(nameMap, function (key, value) {
            if (!value) {
                return;
            }
            var element = $('[name="' + key + '"]');

            // 特殊场景处理text-multiple
            // <input name="multiText[]"/><input name="multiText[]"/><input name="multiText[]"/>
            // key="multiText[2]",value="singleChar"时，找到对应的具体input框
            if (!element.length) {
                var position = "";
                var name = key.replace(/\[([^\[]*)\]$/, function (match, number) {
                    position = number || "";
                    return '[]';
                });
                if (position !== "") {
                    element = $('[name="' + name + '"]');
                }
                if (element.length && fieldUtil.type(element) === 'text-multiple') {
                    element = $(element[position]);
                }
            }

            if (element.length) {
                elements.push({
                    key: key,
                    value: value,
                    element: element
                });
            }
        });
        return elements;
    },
    /**
     *
     * @param expression jsonPath关联表达式
     * 算法描述:
     * 1. 将expression 中的jsonPath转化为nameSchema，并找到对应的dom，对应的Value
     * 2. 将expression jsonPath关联表达式转化为expressParser识别的表达式
     */
    matchExpression: function (name, expression) {
        var json = {};
        var variable = 0;
        var expressionToExcute = expression.replace(/\$\.[\w\[\]\*\.]+/g, function (jsonPath) {
            var varName = 'var' + (variable++);
            json[varName] = getValueFromDomByJsonPath(name, jsonPath);
            return varName;
        });
        return expressionParser.run(expressionToExcute, json);
    }
};